import { useEffect, useState } from 'react';
import Backdrop from '@mui/material/Backdrop';

import './loading-indicator.scss';

import SonevoLoadingIndicator from 'shared/components/loading-indicator/sonevo-loader';

type Props = {
  readonly isLoading: boolean;
  readonly useTimeout?: boolean;
};

const FullPageLoadingIndicator = ({ isLoading, useTimeout }: Readonly<Props>): React.JSX.Element => {
  const [showLoader, setShowLoader] = useState(isLoading && (useTimeout ?? false));

  useEffect(() => {
    if (isLoading && useTimeout) {
      const timer = setTimeout(() => setShowLoader(true), 300);
      return (): void => clearTimeout(timer);
    }
    setShowLoader(isLoading);
  }, [isLoading, useTimeout]);

  if (!showLoader) return <></>;

  return (
    <Backdrop open sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}>
      <SonevoLoadingIndicator size={100} />
    </Backdrop>
  );
};

export default FullPageLoadingIndicator;
